import * as React from "react";
import { Link } from "react-router-dom";
import { Badge, Nav } from "react-bootstrap";
import { OrgInfo } from "@preveil-api";
import { PrivateRoutes, OrgUserRoles, useAppSelector } from "src/common";
import { Icon } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  organization: OrgInfo;
  active_path?: string;
};

function AdminNavigationComponent(props: AllProps) {
  const { active_path, organization } = props;
  const is_admin = !!organization && organization.role === OrgUserRoles.admin;
  const actions_pending = useAppSelector((state: RootState) => state.admin.actions_pending);

  return is_admin ?
    <Nav className="mt-0">
      <Link aria-label="Users"
        className={`nav-link${active_path === PrivateRoutes.users_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.users_route}`}>
        <Icon className="ficon-user" />
        <span>Users</span>
        {
          (!!actions_pending && actions_pending) &&
          <Badge
            data-tooltip-id="pv-tooltip"
            data-tooltip-content="Actions Pending"
            data-tooltip-place="right"
            className="icon">
            <span className="icon-warning"></span>
          </Badge>
        }
      </Link>
      <Link aria-label="Approval Groups"
        className={`nav-link${active_path === PrivateRoutes.approval_groups_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.approval_groups_route}`}>
        <Icon className="ficon-life-buoy" />
        <span>Approval Groups</span>
      </Link>
      <Link aria-label="Trusted Community"
        className={`nav-link${active_path === PrivateRoutes.trusted_community_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.trusted_community_route}`}>
        <Icon className="ficon-users" />
        <span>Trusted Community</span>
      </Link>
      <Link aria-label="User Groups"
        className={`nav-link${active_path === PrivateRoutes.groups_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.groups_route}`}>
        <Icon className="ficon-user-plus" />
        <span>User Groups</span>
      </Link>
      <hr />
      <Link aria-label="Approval Requests"
        className={`nav-link${active_path === PrivateRoutes.requests_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.requests_route}`}>
        <Icon className="ficon-clipboard" />
        <span>Approval Requests</span>
      </Link>
      <Link aria-label="Activity Logs"
        className={`nav-link${active_path === PrivateRoutes.activity_logs_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.activity_logs_route}`}>
        <Icon className="ficon-file-text" />
        <span>Activity Logs</span>
      </Link>
      <Link aria-label="Data Export"
        className={`nav-link${active_path === PrivateRoutes.data_export_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.data_export_route}`}>
        <Icon className="ficon-download-cloud" />
        <span>Data Export</span>
      </Link>
      <Link aria-label="Usage Report"
        className={`nav-link${active_path === PrivateRoutes.usage_report_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.usage_report_route}`}>
        <Icon className="ficon-pie-chart" />
        <span>Usage Report</span>
      </Link>
      <Link aria-label="Secure Email Relay"
        className={`nav-link${active_path === PrivateRoutes.email_relay_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.email_relay_route}`}>
        <Icon className="ficon-mail" />
        <span>Secure Email Relay</span>
      </Link>
      <hr />
      <Link aria-label="General Settings"
        className={`nav-link${active_path === PrivateRoutes.settings_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.settings_route}`}>
        <Icon className="ficon-settings" />
        <span>General Settings</span>
      </Link>
      <Link aria-label="Device Settings"
        className={`nav-link${active_path === PrivateRoutes.device_settings ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.device_settings}`}>
        <Icon className="ficon-monitor" />
        <span>Device Settings</span>
      </Link>
      <Link aria-label="Cloud Lock Settings"
        className={`nav-link${active_path === PrivateRoutes.cloud_lock_route ? " active" : ""}`}
        to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.cloud_lock_route}`}>
        <Icon className="ficon-lock" />
        <span>Cloud Lock Settings</span>
      </Link>
    </Nav> : <></>;
}

export default React.memo(AdminNavigationComponent);
